export const FREIGHT_FFP_STATUS_DRAFT = 'Draft';
export const FREIGHT_FFP_STATUS_QUOTED = 'Quoted';
export const FREIGHT_FFP_STATUS_BOOKED = 'Booked';
export const FREIGHT_FFP_STATUS_CANCELLED = 'Cancelled';

export const FREIGHT_FFP_STATUS_ID: Record<number, string> = {
  1: FREIGHT_FFP_STATUS_DRAFT,
  2: FREIGHT_FFP_STATUS_QUOTED,
  3: FREIGHT_FFP_STATUS_BOOKED,
  4: FREIGHT_FFP_STATUS_CANCELLED,
};
export const mapFreightFfpStatusId = (id: number): string => FREIGHT_FFP_STATUS_ID[id] ?? 'Unknown';
